export default __webpack_public_path__ + "static/media/interacciones_activado.05ff93b0.svg";